import React, { useState, useEffect, useRef } from "react";
import "./ecommerce.scss";
import lensIcon from '../../images/search.svg';
import closeIcon from '../../images/close.png';

const Product = ({ product, addToCart, cartItems }) => {
    const [selectedPrice, setSelectedPrice] = useState(product?.Prices[0] || "");
    const [pricedropdown, setPricedropdown] = useState(false);
    const [addedToCart, setAddedToCart] = useState(false);
    const [zoomed, setIsZoomed] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState("bottom");
    const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });
    const [isZoomActive, setIsZoomActive] = useState(false);

    const priceRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (priceRef.current && !priceRef.current.contains(event.target)) {
                setPricedropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (zoomed) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setIsZoomed(false);
            }
        };

        const handleClickOutsideZoom = (event) => {
            if (zoomed && event.target.closest(".zoomed-wrapper") === null) {
                setIsZoomed(false);
            }
        };

        if (zoomed) {
            document.addEventListener("keydown", handleKeyDown);
            document.addEventListener("mousedown", handleClickOutsideZoom);
        }

        return () => {
            document.body.style.overflow = "auto";
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mousedown", handleClickOutsideZoom);
        };
    }, [zoomed]);

    useEffect(() => {
        const isProductInCart = cartItems.some(item => item.ProductID === product.ProductID);
        setAddedToCart(isProductInCart);
    }, [cartItems, product.ProductID]);

    const toggleDropdown = () => {
        if (priceRef.current) {
            const rect = priceRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            if (rect.bottom + 150 > windowHeight) {
                setDropdownPosition("top");
            } else {
                setDropdownPosition("bottom");
            }
        }
        setPricedropdown(!pricedropdown);
    };

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.target.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;

        setZoomPosition({ x, y });
        setIsZoomActive(true); // Activate zoom when mouse enters
    };

    const handleMouseLeave = () => {
        setIsZoomActive(false); // Reset zoom when mouse leaves
    };

    return (
        <div className="product-card-wrapper">
            <div className="product-card">
                <div className="product-thumb" onClick={() => setIsZoomed(true)}>
                    <div className="thumb-overlay"><img src={lensIcon} alt="Lens" /></div>
                    <img src={product?.ThumbnailURL} alt={product?.ProductName} />
                </div>
                <h3 title={product?.ProductName}>{product?.ProductName}</h3>

                <div className="product-footer">
                    <div className="price-dropdown-wrapper" ref={priceRef}>
                        <div className="price-dropdown-header" onClick={toggleDropdown}>
                            <span>${selectedPrice.QuantityPrice}</span> - <span>{selectedPrice.QuantityThreshold}</span>
                        </div>
                        {pricedropdown && (
                            <ul className={`price-dropdown ${dropdownPosition}`}>
                                {product.Prices.map((price, index) => (
                                    <li key={index} onClick={() => {
                                        setSelectedPrice(price);
                                        setPricedropdown(false);
                                    }}>
                                        <span>${price.QuantityPrice}</span> - <span>{price.QuantityThreshold}</span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>

                    <button
                        className={`cart-btn ${addedToCart ? "added" : ""}`}
                        onClick={() => {
                            addToCart(product, selectedPrice);
                            setAddedToCart(true);
                            //setTimeout(() => setAddedToCart(false), 2000);
                        }}
                    >
                        {addedToCart ? 'Added' : <span>Add to Cart</span>}
                    </button>
                </div>
            </div>
            {zoomed && (
                <div className="zoomed">
                    <div className="zoomed-wrapper">
                        <div className="close" onClick={() => setIsZoomed(false)}>
                            <img src={closeIcon} alt="Close" />
                        </div>
                        <div className="product-thumb" onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
                            <img
                                src={product?.ThumbnailURL}
                                alt={product?.ProductName}
                                style={{
                                    transform: isZoomActive ? "scale(2)" : "scale(1)",
                                    transformOrigin: `${zoomPosition.x}% ${zoomPosition.y}%`,
                                }}
                            />
                        </div>
                        <h3>{product?.ProductName}</h3>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Product;
